export type InstanceCounts = {
	[slotType: string]: number,
};

const instanceCounts: InstanceCounts = {};

export default function getSlotInstance(slotType: string) {
	if (instanceCounts[slotType] === undefined) {
		instanceCounts[slotType] = 0;
	}

	/* eslint-disable no-plusplus */
	return ++instanceCounts[slotType];
	/* eslint-enable no-plusplus */
}
